export function spaceToNBSP(input: string) {
    return input.replace(' ', ' ');
}
